@if (expanded) {
  <mat-button-toggle-group
    class="view-toggle mb-3 pull-right"
    [(ngModel)]="viewMode"
  >
    <mat-button-toggle value="grid">
      <mat-icon>view_module</mat-icon>
    </mat-button-toggle>
    <mat-button-toggle value="list">
      <mat-icon>view_list</mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <div
    class="row col-12 px-0 mx-0"
    [ngClass]="{
      'unified-selected': !!selected,
      'yellow-negative': yellowNegative,
    }"
  >
    <div
      class="column ps-0"
      [ngClass]="{
        'col-6': viewMode === 'grid',
        'col-12': viewMode !== 'grid',
        'pe-0': viewMode !== 'grid',
      }"
    >
      @for (r of data; track r; let i = $index) {
        @if ((viewMode === 'list' || !isOdd(i)) && r.headline !== '') {
          <div
            class="col-12 reason {{
              forceNeutral ? 'neutral' : r.reasonType.toLowerCase()
            }}"
            [ngClass]="{ mass: org.toLowerCase() === 'mm' }"
          >
            <strong class="header">
              <img
                src="{{
                  forceNeutral
                    ? './assets/' + path + 'neutral' + '.png'
                    : './assets/' + path + r.reasonType.toLowerCase() + '.png'
                }}"
                alt="reason icon"
              />
              <div>
                <span [innerHTML]="r.headline"></span>
                <span *hasPermission="'!RelevanceHideReasonScores'">
                  | {{ r.score }}
                </span>
              </div>
              @if (tags?.criteria) {
                @switch (tags.criteria) {
                  @case ('score') {
                    <span class="pull-right score-tag">
                      {{ r.score > 0 ? tags.positive : tags.negative }}
                    </span>
                  }
                  @case ('reasonType') {
                    @switch (r.reasonType.toLowerCase()) {
                      @case ('positive') {
                        <span class="pull-right score-tag">
                          {{ tags.positive }}
                        </span>
                      }
                      @case ('neutral') {
                        <span class="pull-right score-tag">
                          {{ tags.neutral }}
                        </span>
                      }
                      @case ('negative') {
                        <span class="pull-right score-tag">
                          {{ tags.negative }}
                        </span>
                      }
                    }
                  }
                }
              }
              @if (showAccountLinking(r)) {
                @if (['P', 'U'].includes(accountLinkingStatus)) {
                  <button
                    color="accent"
                    matButton="elevated"
                    type="button"
                    class="linking-button"
                    matTooltip="Click to Manage"
                    [matTooltipShowDelay]="500"
                    (click)="linkingNav()"
                  >
                    <mat-icon>add_link</mat-icon> Add Link
                  </button>
                } @else if (accountLinkingStatus === 'L') {
                  <button
                    matButton="elevated"
                    type="button"
                    class="linking-button"
                    matTooltip="Click to Manage"
                    [matTooltipShowDelay]="500"
                    (click)="linkingNav()"
                  >
                    <mat-icon>task_alt</mat-icon> Link Added
                  </button>
                }
              }
            </strong>
            @if (r.explanation && !hideExplanations) {
              <p class="explanation" [innerHTML]="r.explanation"></p>
            }
          </div>
        }
      }
    </div>
    @if (viewMode === 'grid') {
      <div
        class="column pe-0"
        [ngClass]="{
          'col-6': viewMode === 'grid',
          'col-12': viewMode !== 'grid',
          'ps-0': viewMode !== 'grid',
        }"
      >
        @for (r of data; track r; let i = $index) {
          @if (isOdd(i) && r.headline !== '') {
            <div
              class="col-12 reason {{
                forceNeutral ? 'neutral' : r.reasonType.toLowerCase()
              }}"
              [ngClass]="{ mass: org.toLowerCase() === 'mm' }"
            >
              <strong class="header">
                <img
                  src="{{
                    forceNeutral
                      ? './assets/' + path + 'neutral' + '.png'
                      : './assets/' + path + r.reasonType.toLowerCase() + '.png'
                  }}"
                  alt="reason icon"
                />
                <div>
                  <span [innerHTML]="r.headline"></span>
                  <span *hasPermission="'!RelevanceHideReasonScores'">
                    | {{ r.score }}
                  </span>
                </div>
                @if (tags?.criteria) {
                  @switch (tags.criteria) {
                    @case ('score') {
                      <span class="pull-right score-tag">{{
                        r.score > 0 ? tags.positive : tags.negative
                      }}</span>
                    }
                    @case ('reasonType') {
                      @switch (r.reasonType.toLowerCase()) {
                        @case ('positive') {
                          <span class="pull-right score-tag">
                            {{ tags.positive }}
                          </span>
                        }
                        @case ('neutral') {
                          <span class="pull-right score-tag">
                            {{ tags.neutral }}
                          </span>
                        }
                        @case ('negative') {
                          <span class="pull-right score-tag">
                            {{ tags.negative }}
                          </span>
                        }
                      }
                    }
                  }
                }
              </strong>
              @if (r.explanation) {
                <p class="explanation" [innerHTML]="r.explanation"></p>
              }
            </div>
          }
        }
      </div>
    }
  </div>
}
